// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"757935bf","258":"7f6796d3","486":"744ac925","500":"d947b24f","503":"8e5bec84","648":"24916db7","961":"192479a7"}[chunkId] + ".chunk.js";
};